import { Button } from "@carbon/react";
import { supabase } from "../../services/supabase";

import styles from "./Profile.module.scss";

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN;

type ProfileProps = {
  name: string;
  email: string;
  onLogout: () => void;
};

const Profile: React.FC<ProfileProps> = ({ name, email, onLogout }) => {
  const handleLogout = async () => {
    await supabase.auth.signOut();
    await fetch(`${API_DOMAIN}/api/logout`, {
      method: "POST",
      credentials: "include",
    });
    onLogout();
  };

  return (
    <div className={styles.profile}>
      <div>
        <h2>Welcome</h2>
        <p>Name: {name}</p>
        <p>Email: {email}</p>
      </div>
      <Button onClick={handleLogout} kind="secondary" className={styles.profile__logoutButton}>
        Log out
      </Button>
    </div>
  );
};

export default Profile;
